import CardGiftcardIcon from '@mui/icons-material/CardGiftcard'
import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'

export const routesRewardsUser = [
  {
    route: 'MaCagnotte',
    text: 'Ma cagnotte',
    mobileText: 'Cagnotte',
    t: 'routes.frontoffice.school.cagnotte',
    href: '/frontoffice/school/cagnotte',
    icon: CardGiftcardIcon,
    menuHeader: true,
    // Menu v2 : entree de NIVEAU 1, EN BAS du menu — les points suivent l'UTILISATEUR,
    // pas un module : la cagnotte ne doit donc pas etre rangee dans une section d'entite.
    menuFlat: 'bottom' as const,
    position: 100,
    positionMobile: 300,
    fnBadge: ({ dataMyProfile }) =>
      !!dataMyProfile?.counterTaskEntityForMenu
        ? JSON.parse(dataMyProfile?.counterTaskEntityForMenu)?.walletsAmountPotsGiftsOne
        : 0,
  },
]

export const getFrontOfficeInsightRewardsUser = routesRewardsUser.map(route => ({
  ...route,
  entity: [EntityList.PHARMEDINSIGHT],
  roles: [
    CONSTANTS.ROLE_DYNAMIC_ROUTE_INSIGHT_USER_TEAM,
    CONSTANTS.ROLE_DYNAMIC_ROUTE_STUDENT_USER,
  ],
}))
